import GenericCreateForm from "../../../../components/GenericCreateForm";

function CreateActiveLocation() {
  return (
    <GenericCreateForm
      title="Ubicación de Activo"
      endpoint="/active-locations"
      backTo="/actives/locations"
    />
  );
}

export default CreateActiveLocation;
